import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { Trans } from 'react-i18next';
import { LEGEND_BY_TYPE } from '../../rainfall/map/RinfallStatusColor';

const useStyles = makeStyles({
  legendContainer: {
    zIndex: 99999,
    marginTop: 10,
  },
  legend: {
    height: '20px',
    width: '20px',
    marginRight: 10,
    border: '1px solid #DBE5EC',
    flexShrink: 0,
  },
  scroll: {
    maxHeight: 320,
    overflowY: 'auto',
  },
});

export default function LegendObsRain({ rainfallType = 'rainfallToday' }) {
  const classes = useStyles();

  const items = LEGEND_BY_TYPE[rainfallType] || [];
  if (items.length === 0) return null;

  // เรียงจากค่ามากไปน้อย แล้วย้าย "ไม่มีข้อมูล" ไปท้ายสุด
  const [noData, ...ranges] = items;
  const ordered = [
    ...ranges.reverse(),
    { ...noData, rangeTitle: <Trans>ไม่มีข้อมูล</Trans> },
  ];

  return (
    <div className={classes.legendContainer}>
      <Paper style={{ opacity: '0.9', backgroundColor: '#EAEAEA' }}>
        <Box p={1} className={classes.scroll}>
          {ordered.map((item, index) => (
            <Grid
              container
              alignItems="center"
              wrap="nowrap"
              key={index}
              style={{ marginBottom: 2 }}
            >
              <Grid item>
                <div
                  style={{ backgroundColor: item.statusColor }}
                  className={classes.legend}
                />
              </Grid>
              <Grid item>
                <Typography
                  variant="subtitle2"
                  style={{ fontFamily: 'Kanit', fontSize: 12 }}
                >
                  {item.rangeTitle}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Paper>
    </div>
  );
}